import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@/../tailwind.config';

const {
  theme: {colors},
} = resolveConfig(tailwindConfig);

/**
 * Retrieves the theme color based on the provided color key.
 * This allows us to transform a custom theme color into its hex string value.
 * @param color - The color key to retrieve the theme color for.
 * @returns The theme color value for the provided color key, or `null` if the color key is invalid.
 */
export function getThemeColor(color: string) {
  const value = colors[color as keyof typeof colors];
  if (!value) return null;
  if (typeof value === 'string') {
    return value;
  }
  // For custom colors with hover and active states, we need to return the DEFAULT value.
  return (value as {DEFAULT: string}).DEFAULT ?? null;
}
